import { CommonModule } from '@angular/common';
import { ChangeDetectorRef, Component, Inject, Input, SimpleChanges,Output,EventEmitter } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { MatListModule } from '@angular/material/list';
import {MatRadioModule} from '@angular/material/radio';
import {FormsModule} from '@angular/forms';
import { DialogData } from '../../dialogs/options-dialog/options-dialog.component';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MyBoolean, OrderDetails, OrderDetailsNew, ToothData } from '../../../models/order.models';
import { MatSliderModule } from '@angular/material/slider';
import { DataService } from '../../../Services/data.service';
import { MagnifierComponent } from '../../magnifier/magnifier.component';
import { MatCheckboxModule } from '@angular/material/checkbox';

@Component({
  selector: 'app-abutment-displace',
  standalone: true,
  imports: [MatSliderModule, MatDialogModule, CommonModule, MatListModule, MatButtonModule, MatRadioModule, FormsModule, MatFormFieldModule, MatInputModule, MatSelectModule, MagnifierComponent,MatCheckboxModule],
  templateUrl: './abutment-displace.component.html',
  styleUrls: ['./abutment-displace.component.css', '../../../../style-custom.css'],
})
export class AbutmentDisplaceComponent {

  @Input() orderDetailsNew!: OrderDetailsNew;
  @Input() showSlider: MyBoolean | undefined;
  @Input() readonly: boolean = false;
  @Input() anterior!: boolean;
  @Input() teeth!: number[];
  @Output() abutmentStep3Change = new EventEmitter<string>();
 @Input() abutmentSelectedTeeth: number[] = [];
  
  q1DefaultValue: string = '1/3 of the surface';
  q2DefaultValue: string = '0.03 mm light occlusion (standard)';
  // q3DefaultValue: string = 'Buccal light equator, approx. 1.6 mm distance cervical (Standard)';

  constructor(public dataService: DataService) { }

  ngOnInit() {
    if(this.orderDetailsNew){
      this.orderDetailsNew.props['a-Mesial and distal contact point-'+this.anterior] = this.orderDetailsNew.props['a-Mesial and distal contact point-'+this.anterior] ? this.orderDetailsNew.props['a-Mesial and distal contact point-'+this.anterior] : this.q1DefaultValue;
      this.orderDetailsNew.props['a-Occlusal contact-'+this.anterior] = this.orderDetailsNew.props['a-Occlusal contact-'+this.anterior] ? this.orderDetailsNew.props['a-Occlusal contact-'+this.anterior] : this.q2DefaultValue;
    }
  }

  rearrangedTeethOrderIgnoringBridgedTeeth(teeth: number[]): string {
    var bridgedTeethNotStartEnd = this.orderDetailsNew.bridges.map((bridge) => {
      return bridge.bridgedTeeth.filter((tooth) => tooth !== bridge.start && tooth !== bridge.end);
    }).flat();

    return this.dataService.rearrangedTeethOrder(teeth.filter((tooth) => tooth != 18 && tooth != 28 && tooth != 48 && tooth != 38 && !bridgedTeethNotStartEnd.includes(tooth)));
  }
 
  close(): void {
    if(this.showSlider){
      this.showSlider.value = false;
    }
  }
  get isAbutmentStep2NarrowSelected(): boolean {
  if (!this.abutmentSelectedTeeth?.length) return false;

  return this.orderDetailsNew.toothData.some(
    t => this.abutmentSelectedTeeth.includes(t.teeth) && t['abutmentStep2'] === "Narrow healing space"
  );
}

get isAbutmentStep2StraightSelected(): boolean {
  if (!this.abutmentSelectedTeeth?.length) return false;

  return this.orderDetailsNew.toothData.some(
    t => this.abutmentSelectedTeeth.includes(t.teeth) && t['abutmentStep2'] === "Straight"
  );
}
get isAbutmentStep2ConvexSelected(): boolean {    
  if (!this.abutmentSelectedTeeth?.length) return false;

  return this.orderDetailsNew.toothData.some(
    t => this.abutmentSelectedTeeth.includes(t.teeth) && t['abutmentStep2'] === "Convex"
  );
}

  get shouldNotIdealMessageDisplay(): boolean {
  if (!this.abutmentSelectedTeeth?.length) return false;

  return this.orderDetailsNew.toothData.some(
    t =>
      this.abutmentSelectedTeeth.includes(t.teeth) &&
      t['abutmentStep2'] === "Convex" &&
      (t['abutmentStep3'] === "A" || t['abutmentStep3'] === "B" || t['abutmentStep3'] === "C")
  );
}

get displayWarningMessage(): boolean {
  if (!this.abutmentSelectedTeeth?.length) return false;

  return this.orderDetailsNew.toothData.some(
    t =>
      this.abutmentSelectedTeeth.includes(t.teeth) &&
      t['abutmentStep2'] === "Straight" &&
      (t['abutmentStep3'] === "A" || t['abutmentStep3'] === "B")
  );
}
get isOptionEActive(): boolean {
  if (!this.abutmentSelectedTeeth?.length) return false;

  return this.orderDetailsNew.toothData.some(
    t =>
      this.abutmentSelectedTeeth.includes(t.teeth) &&
      t['abutmentStep1'] === "Narrow healing space" &&
      t['abutmentStep3'] === "D"
  );
}

onAabutmentStep3Selection(AbutmentStep3Option: string) {
  if (!this.abutmentSelectedTeeth?.length) return;

  this.orderDetailsNew.toothData.forEach(t => {
    if (this.abutmentSelectedTeeth.includes(t.teeth)) {
      t['abutmentStep3'] = AbutmentStep3Option;
    }
  });

  this.abutmentStep3Change.emit(AbutmentStep3Option);
}
  
 shouldBeCheckedForTooth(step: string, value: string): boolean {
  if (!this.abutmentSelectedTeeth?.length) return false;

  return this.orderDetailsNew.toothData.some(
    t => this.abutmentSelectedTeeth.includes(t.teeth) && t[step] === value
  );
}

}
